import { OidcClient as e, OidcClient as t, OidcError as n, OidcErrorCode as r, OidcLocation as i, OidcLocation as a, OidcStateError as o, OidcStateErrorCode as s, PushedAuthorizationRequestError as c, PushedAuthorizationRequestErrorCode as l, TokenAutomaticRenewMode as u, TokenRenewMode as d, getFetchDefault as f, getParseQueryStringFromLocation as p, getPath as m, isOidcError as h, isOidcStateError as g, isPushedAuthorizationRequestError as _ } from "@axa-fr/oidc-client";
import v, { useCallback as y, useEffect as b, useRef as x, useState as S } from "react";
import { Fragment as C, jsx as w, jsxs as T } from "react/jsx-runtime";
//#region src/FetchToken.tsx
var E = "default", D = (e = null, t = E, n = !1) => (r) => (i) => {
	let { fetch: a } = O(e || i.fetch, t, n);
	return /* @__PURE__ */ w(r, {
		...i,
		fetch: a
	});
}, O = (e = null, n = E, r = !1) => {
	let i = e || window.fetch, a = t.getOrThrow;
	return { fetch: y(async (e, t) => await a(n).fetchWithTokens(i, r)(e, t), [
		i,
		n,
		r
	]) };
}, k = () => /* @__PURE__ */ w("div", {
	className: "oidc-authenticating",
	children: /* @__PURE__ */ T("div", {
		className: "oidc-authenticating__container",
		children: [/* @__PURE__ */ w("h1", {
			className: "oidc-authenticating__title",
			children: "Error authentication"
		}), /* @__PURE__ */ w("p", {
			className: "oidc-authenticating__content",
			children: "An error occurred during authentication."
		})]
	})
}), ee = () => /* @__PURE__ */ w("div", {
	className: "oidc-authenticating",
	children: /* @__PURE__ */ T("div", {
		className: "oidc-authenticating__container",
		children: [/* @__PURE__ */ w("h1", {
			className: "oidc-authenticating__title",
			children: "Authentication in progress"
		}), /* @__PURE__ */ w("p", {
			className: "oidc-authenticating__content",
			children: "You will be redirected to the login page."
		})]
	})
}), A = () => Math.random().toString(36).slice(2, 8), j = (e, t) => (n, r) => {
	if (typeof e.CustomEvent == "function") return new e.CustomEvent(n, r);
	let i = r || {
		bubbles: !1,
		cancelable: !1,
		detail: void 0
	}, a = t.createEvent("CustomEvent");
	return a.initCustomEvent(n, i.bubbles, i.cancelable, i.detail), a.prototype = e.Event.prototype, a;
}, M = (e, t, n) => ({ replaceState: (r, i) => {
	let a = n(), o = i || e.history.state;
	e.history.replaceState({
		key: a,
		state: o
	}, null, r), e.dispatchEvent(t("popstate"));
} }), N = () => M(window, j(window, document), A), P = () => /* @__PURE__ */ w("div", {
	className: "oidc-callback",
	children: /* @__PURE__ */ T("div", {
		className: "oidc-callback__container",
		children: [/* @__PURE__ */ w("h1", {
			className: "oidc-callback__title",
			children: "Authentication complete"
		}), /* @__PURE__ */ w("p", {
			className: "oidc-callback__content",
			children: "You will be redirected to your application."
		})]
	})
}), F = 200, I = (e, t = window) => t.location.pathname === e || e === "/", L = ({ callBackError: e, callBackSuccess: n, configurationName: r, withCustomHistory: i, navigateAfterCallback: a }) => {
	let [o, s] = S(!1);
	return b(() => {
		let e = !0;
		return (async () => {
			let n = t.getOrThrow;
			try {
				let o = n(r), { callbackPath: c } = await o.loginCallbackAsync(), l = c || "/";
				if (a) try {
					await a(l), o.publishEvent(t.eventNames.loginCallbackAsync_navigated, {
						configurationName: r,
						callbackPath: l
					});
				} catch (n) {
					o.publishEvent(t.eventNames.loginCallbackAsync_navigation_error, {
						configurationName: r,
						callbackPath: l,
						error: n
					}), e && (console.warn(n), s(!0));
				}
				else (i ? i() : N()).replaceState(l), await new Promise((e) => {
					setTimeout(() => {
						e();
					}, F);
				}), e && (I(l) ? o.publishEvent(t.eventNames.loginCallbackAsync_navigated, {
					configurationName: r,
					callbackPath: l
				}) : (o.publishEvent(t.eventNames.loginCallbackAsync_navigation_error, {
					configurationName: r,
					callbackPath: l,
					error: /* @__PURE__ */ Error(`Navigation did not commit: expected "${l}" but found "${window.location.pathname}"`)
				}), s(!0)));
			} catch (t) {
				e && (console.warn(t), s(!0));
			}
		})(), () => {
			e = !1;
		};
	}, []), w(o ? e || k : n || P, { configurationName: r });
}, R = () => /* @__PURE__ */ w("span", {
	className: "oidc-loading",
	children: "Loading"
}), te = () => /* @__PURE__ */ w("div", {
	className: "oidc-loading-timeout",
	children: /* @__PURE__ */ T("div", {
		className: "oidc-loading-timeout__container",
		children: [/* @__PURE__ */ w("h1", {
			className: "oidc-loading-timeout__title",
			children: "Loading timeout"
		}), /* @__PURE__ */ w("p", {
			className: "oidc-loading-timeout__content",
			children: "Authentication is taking longer than expected. Please try refreshing the page."
		})]
	})
}), ne = () => /* @__PURE__ */ w("div", {
	className: "oidc-serviceworker",
	children: /* @__PURE__ */ T("div", {
		className: "oidc-serviceworker__container",
		children: [/* @__PURE__ */ w("h1", {
			className: "oidc-serviceworker__title",
			children: "Unable to authenticate on this browser"
		}), /* @__PURE__ */ w("p", {
			className: "oidc-serviceworker__content",
			children: "Your browser is not secure enough to make authentication work. Try updating your browser or use a newer browser."
		})]
	})
}), re = () => /* @__PURE__ */ w("div", {
	className: "oidc-session-lost",
	children: /* @__PURE__ */ T("div", {
		className: "oidc-session-lost__container",
		children: [/* @__PURE__ */ w("h1", {
			className: "oidc-session-lost__title",
			children: "Session timed out"
		}), /* @__PURE__ */ w("p", {
			className: "oidc-session-lost__content",
			children: "Your session has expired. Please re-authenticate."
		})]
	})
}), z = ({ configurationName: e }) => (b(() => {
	(async () => {
		t.getOrThrow(e).silentLoginCallbackAsync();
	})().catch((e) => {
		console.error("Error during silent login callback:", e);
	});
}, [e]), null), B = ({ configurationName: e }) => {
	let n = p(window.location.href), r = t.getOrThrow, i = r(e), a = null;
	for (let [e, t] of Object.entries(n)) e !== "state" && e !== "scope" && (a ??= {}, a[e] = t);
	return b(() => {
		i.tokens || i.loginAsync(null, a, !0, n.scope);
	}, []), /* @__PURE__ */ w(C, {});
}, ie = v.memo(({ callbackErrorComponent: e, callbackSuccessComponent: t, redirect_uri: n, silent_redirect_uri: r, silent_login_uri: i, children: a, configurationName: o, withCustomHistory: s = null, navigateAfterCallback: c = null }) => {
	let l = window ? m(window.location.href) : "", [u, d] = S(l);
	b(() => {
		let e = () => d(m(window.location.href));
		return e(), window.addEventListener("popstate", e, !1), () => window.removeEventListener("popstate", e, !1);
	}, []);
	let f = m(n);
	return r && u === m(r) ? /* @__PURE__ */ w(z, { configurationName: o }) : i && u === m(i) ? /* @__PURE__ */ w(B, { configurationName: o }) : u === f ? /* @__PURE__ */ w(L, {
		callBackError: e,
		callBackSuccess: t,
		configurationName: o,
		withCustomHistory: s,
		navigateAfterCallback: c
	}) : /* @__PURE__ */ w(C, { children: a });
}), V = {
	name: "",
	data: null
}, ae = ({ loadingComponent: e, children: n, configurationName: r }) => {
	let [i, a] = S(!0), o = t.get, s = o(r);
	return b(() => {
		let e = !0;
		return s && s.tryKeepExistingSessionAsync().then(() => {
			e && a(!1);
		}), () => {
			e = !1;
		};
	}, [r]), /* @__PURE__ */ w(C, { children: i ? /* @__PURE__ */ w(e, { configurationName: r }) : /* @__PURE__ */ w(C, { children: n }) });
}, H = ({ isLoading: e, loadingComponent: t, children: n, configurationName: r }) => e ? /* @__PURE__ */ w(t, {
	configurationName: r,
	children: n
}) : /* @__PURE__ */ w(C, { children: n }), oe = 3e4, se = (e) => e === t.eventNames.token_acquired || e === t.eventNames.token_renewed || e === t.eventNames.loginCallbackAsync_end || e === t.eventNames.tryKeepExistingSessionAsync_end || e === t.eventNames.tryKeepExistingSessionAsync_error, U = ({ children: e, configuration: n, configurationName: r = "default", callbackSuccessComponent: i = P, authenticatingComponent: o = ee, loadingComponent: s = R, loadingTimeoutComponent: c = te, serviceWorkerNotSupportedComponent: l = ne, authenticatingErrorComponent: u = k, sessionLostComponent: d = re, onSessionLost: p = null, onLogoutFromAnotherTab: m = null, onLogoutFromSameTab: h = null, withCustomHistory: g = null, navigateAfterCallback: _ = null, onEvent: v = null, getFetch: y = null, location: x = null }) => {
	if (n && n.redirect_uri && n.silent_redirect_uri && n.redirect_uri === n.silent_redirect_uri) throw Error("redirect_uri and silent_redirect_uri must be different");
	let C = (e = "default") => t.getOrCreate(y ?? f, x ?? new a())(n, e), [T, E] = S(V), [D, O] = S(!0), [A, j] = S(r);
	b(() => {
		let e = C(r).subscribeEvents((e, t) => {
			v && v(r, e, t);
		});
		return () => {
			C(r).removeEventSubscription(e);
		};
	}, [r, v]), b(() => {
		let e = C(r).subscribeEvents((e, r) => {
			if (e === t.eventNames.loginAsync_begin ? O(!0) : se(e) && O(!1), e === t.eventNames.refreshTokensAsync_error || e === t.eventNames.syncTokensAsync_error) {
				if (p != null) {
					p();
					return;
				}
				E({
					name: e,
					data: r
				});
			} else if (e === t.eventNames.logout_from_another_tab) {
				if (m != null) {
					m();
					return;
				}
				E({
					name: e,
					data: r
				});
			} else e === t.eventNames.logout_from_same_tab ? h?.() : (e === t.eventNames.loadingTimeout_error || e === t.eventNames.loginAsync_begin || e === t.eventNames.loginCallbackAsync_end || e === t.eventNames.loginAsync_error || e === t.eventNames.loginCallbackAsync_error || e === t.eventNames.service_worker_not_supported_by_browser && n.service_worker_only === !0) && E({
				name: e,
				data: r
			});
		});
		return queueMicrotask(() => {
			j(r);
		}), () => {
			C(r).removeEventSubscription(e), E(V), O(!0);
		};
	}, [n, r]), b(() => {
		let e = n?.loading_timeout_ms ?? oe;
		if (e <= 0 || !D || C(r)?.tokens != null || T.name !== "" && T.name !== t.eventNames.loginAsync_begin) return;
		let i = setTimeout(() => {
			C(r).publishEvent(t.eventNames.loadingTimeout_error, { timeoutMs: e });
		}, e);
		return () => clearTimeout(i);
	}, [
		T.name,
		D,
		r,
		n
	]);
	let M = d, N = o, F = s, I = c, L = l, z = u, B = A !== r, U = C(r);
	switch (T.name) {
		case t.eventNames.service_worker_not_supported_by_browser: return /* @__PURE__ */ w(H, {
			loadingComponent: F,
			isLoading: B,
			configurationName: r,
			children: /* @__PURE__ */ w(L, { configurationName: r })
		});
		case t.eventNames.loginAsync_begin: return /* @__PURE__ */ w(H, {
			loadingComponent: F,
			isLoading: B,
			configurationName: r,
			children: /* @__PURE__ */ w(N, { configurationName: r })
		});
		case t.eventNames.loadingTimeout_error: return /* @__PURE__ */ w(H, {
			loadingComponent: F,
			isLoading: B,
			configurationName: r,
			children: /* @__PURE__ */ w(I, { configurationName: r })
		});
		case t.eventNames.loginAsync_error:
		case t.eventNames.loginCallbackAsync_error: return /* @__PURE__ */ w(H, {
			loadingComponent: F,
			isLoading: B,
			configurationName: r,
			children: /* @__PURE__ */ w(z, { configurationName: r })
		});
		case t.eventNames.refreshTokensAsync_error:
		case t.eventNames.syncTokensAsync_error:
		case t.eventNames.logout_from_another_tab: return /* @__PURE__ */ w(H, {
			loadingComponent: F,
			isLoading: B,
			configurationName: r,
			children: /* @__PURE__ */ w(M, { configurationName: r })
		});
		default: return /* @__PURE__ */ w(H, {
			loadingComponent: F,
			isLoading: B,
			configurationName: r,
			children: /* @__PURE__ */ w(ie, {
				redirect_uri: U.configuration.redirect_uri,
				silent_redirect_uri: U.configuration.silent_redirect_uri,
				silent_login_uri: U.configuration.silent_login_uri,
				callbackSuccessComponent: i,
				callbackErrorComponent: u,
				authenticatingComponent: o,
				configurationName: r,
				withCustomHistory: g,
				navigateAfterCallback: _,
				location: x ?? new a(),
				children: /* @__PURE__ */ w(ae, {
					loadingComponent: F,
					configurationName: r,
					children: e
				})
			})
		});
	}
}, W = ({ children: e, callbackPath: n = null, extras: r = null, configurationName: i = "default" }) => {
	let a = t.getOrThrow, o = a(i);
	return b(() => {
		!o.tokens && !o.isLoggingOut && o.loginAsync(n, r);
	}, [
		i,
		n,
		r
	]), o.tokens ? /* @__PURE__ */ w(C, { children: e }) : null;
}, G = (e, t = null, n = null, r = "default") => (i) => /* @__PURE__ */ w(W, {
	callbackPath: t,
	extras: n,
	configurationName: r,
	children: /* @__PURE__ */ w(e, { ...i })
}), K = /* @__PURE__ */ new Set(), q = (e) => {
	K.has(e) || (K.add(e), console.warn(`@axa-fr/react-oidc: no OIDC configuration found for "${e}". Make sure to wrap your component tree with <OidcProvider configurationName="${e}">. Hooks are returning safe default values (issue #1679).`));
}, J = "default", Y = (e, t) => {
	let n = e(t);
	return n ? n.tokens != null : !1;
}, X = (e) => e === t.eventNames.token_renewed || e === t.eventNames.token_acquired || e === t.eventNames.logout_from_another_tab || e === t.eventNames.logout_from_same_tab || e === t.eventNames.refreshTokensAsync_error || e === t.eventNames.syncTokensAsync_error, ce = (e = J) => {
	let n = t.get, [r, i] = S(() => Y(n, e));
	return b(() => {
		let r = !0, a = n(e);
		if (!a) {
			q(e);
			return;
		}
		let o = a.subscribeEvents((a, o) => {
			(a === t.eventNames.logout_from_another_tab || a === t.eventNames.logout_from_same_tab || a === t.eventNames.token_acquired) && r && i(Y(n, e));
		});
		return () => {
			r = !1, a.removeEventSubscription(o);
		};
	}, [e]), {
		login: (t = void 0, r = void 0, i = !1, a = void 0) => {
			let o = n(e);
			return o ? o.loginAsync(t, r, !1, a, i) : (q(e), Promise.resolve());
		},
		logout: (t = void 0, r = void 0) => {
			let i = n(e);
			return i ? i.logoutAsync(t, r) : (q(e), Promise.resolve());
		},
		renewTokens: async (t = void 0) => {
			let r = n(e);
			if (!r) return q(e), {
				accessToken: null,
				accessTokenPayload: null,
				idToken: null,
				idTokenPayload: null
			};
			let i = await r.renewTokensAsync(t);
			return {
				accessToken: i.accessToken,
				accessTokenPayload: i.accessTokenPayload,
				idToken: i.idToken,
				idTokenPayload: i.idTokenPayload
			};
		},
		isAuthenticated: r
	};
}, Z = {
	accessToken: null,
	accessTokenPayload: null
}, Q = (e) => {
	let n = t.get, r = n(e);
	if (!r) return Z;
	if (r.tokens) {
		let e = r.tokens;
		return {
			accessToken: e.accessToken,
			accessTokenPayload: e.accessTokenPayload,
			generateDemonstrationOfProofOfPossessionAsync: r.configuration.demonstrating_proof_of_possession ? (t, n) => r.generateDemonstrationOfProofOfPossessionAsync(e.accessToken, t, n) : null
		};
	}
	return Z;
};
function le(e, t) {
	return e.configuration.demonstrating_proof_of_possession ? (n, r, i = {}) => e.generateDemonstrationOfProofOfPossessionAsync(t.accessToken, n, r, i) : null;
}
var ue = (e = J) => {
	let n = t.get, [r, i] = S(() => Q(e));
	return b(() => {
		let t = !0, r = n(e);
		if (!r) {
			q(e);
			return;
		}
		let a = r.subscribeEvents((e, n) => {
			if (X(e) && t) {
				let e = r.tokens;
				i(e == null ? Z : {
					accessToken: e.accessToken,
					accessTokenPayload: e.accessTokenPayload,
					generateDemonstrationOfProofOfPossessionAsync: le(r, e)
				});
			}
		});
		return () => {
			t = !1, r.removeEventSubscription(a);
		};
	}, [e]), r;
}, $ = {
	idToken: null,
	idTokenPayload: null
}, de = (e) => {
	let n = t.get, r = n(e);
	if (!r) return $;
	if (r.tokens) {
		let e = r.tokens;
		return {
			idToken: e.idToken,
			idTokenPayload: e.idTokenPayload
		};
	}
	return $;
}, fe = (e = J) => {
	let n = t.get, [r, i] = S(() => de(e));
	return b(() => {
		let t = !0, r = n(e);
		if (!r) {
			q(e);
			return;
		}
		let a = r.subscribeEvents((e, n) => {
			if (X(e) && t) {
				let e = r.tokens;
				i(e == null ? $ : {
					idToken: e.idToken,
					idTokenPayload: e.idTokenPayload
				});
			}
		});
		return () => {
			t = !1, r.removeEventSubscription(a);
		};
	}, [e]), r;
}, pe = /* @__PURE__ */ function(e) {
	return e.Unauthenticated = "Unauthenticated", e.Loading = "Loading user", e.Loaded = "User loaded", e.LoadingError = "Error loading user", e;
}({}), me = (e = "default", n = !1) => {
	let r = t.get(e), i = r ? r.userInfo() : null, [a, o] = S({
		user: i,
		status: i ? "User loaded" : "Unauthenticated"
	}), [s, c] = S(+!!i), l = x(+!!i);
	return b(() => {
		let r = t.get(e), i = !0;
		if (!r) {
			q(e);
			return;
		}
		if (r.tokens) {
			let e = s === l.current;
			if (e && r.userInfo()) return;
			l.current = s, queueMicrotask(() => {
				i && o({
					...a,
					status: "Loading user"
				});
			}), r.userInfoAsync(!e, n).then((e) => {
				i && o({
					user: e,
					status: "User loaded"
				});
			}).catch(() => o({
				...a,
				status: "Error loading user"
			}));
		} else queueMicrotask(() => {
			i && o({
				user: null,
				status: "Unauthenticated"
			});
		});
		let c = r.subscribeEvents((e) => {
			(e === t.eventNames.logout_from_another_tab || e === t.eventNames.logout_from_same_tab) && i && o({
				user: null,
				status: "Unauthenticated"
			});
		});
		return () => {
			i = !1, r.removeEventSubscription(c);
		};
	}, [
		s,
		e,
		n
	]), {
		oidcUser: a.user,
		oidcUserLoadingState: a.status,
		reloadOidcUser: () => {
			c(s + 1);
		}
	};
};
//#endregion
export { e as OidcClient, n as OidcError, r as OidcErrorCode, i as OidcLocation, U as OidcProvider, W as OidcSecure, o as OidcStateError, s as OidcStateErrorCode, pe as OidcUserStatus, c as PushedAuthorizationRequestError, l as PushedAuthorizationRequestErrorCode, u as TokenAutomaticRenewMode, d as TokenRenewMode, h as isOidcError, g as isOidcStateError, _ as isPushedAuthorizationRequestError, ce as useOidc, ue as useOidcAccessToken, O as useOidcFetch, fe as useOidcIdToken, me as useOidcUser, D as withOidcFetch, G as withOidcSecure };
